import { delayedCall, dispatcher, ingenuity, killDelayedCall, Meter } from "@quest/base-core";
import {
  RetriggerController,
  SlotAnimationConstant,
  SlotConstantsBehavior,
  SlotEventConstantsBehavior,
  SoundConstant,
} from "@quest/murka-games-behavior-panther";
import { Linear } from "@quest/pixi-bridge";
import { gameConstants } from "../Constants/gameConstants";
import { GameParserModel } from "../Platform/GameParserModel";
import { eventDispatchers } from "../Constants/EventDispatchers";
export class RetriggerControllerGame extends RetriggerController {
  protected retriggerText2: Meter;

  protected initializeElements(): void {
    super.initializeElements();
    this.retriggerText2 = this.view.getMeterById("retriggerText") as Meter;
    this.ANIMATION_RETRIGGER_BASE = "freespins_intro_in_bg_desktop";
    this.ANIMATION_RETRIGGER_TEXT = "freespins_intro_in_fg";
    this.ANIMATION_RETRIGGER_OUT_BASE = "freespins_intro_out_bg_desktop";
    this.ANIMATION_RETRIGGER_OUT_TEXT = "freespins_intro_out_fg";
    this.ANIMATION_RETRIGGER_BASE_PORTRAIT = "freespins_intro_in_bg_portrait";
    this.ANIMATION_RETRIGGER_TEXT_PORTRAIT = "freespins_intro_in_fg";
    this.ANIMATION_RETRIGGER_OUT_BASE_PORTRAIT = "freespins_intro_out_bg_portrait";
    this.ANIMATION_RETRIGGER_OUT_TEXT_PORTRAIT = "freespins_intro_out_fg";
  }

  protected initializePortraitComponent(): void {
    this.retriggerPortraitSpine = this.view.getSpineById("Freespins_intro_portrait");
  }
  /**
     * overrided to handle game specific flow
     */
  protected onRetriggerShow(): void {
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_FG_BUTTON_PANEL_ON_TOP);
    dispatcher.fireEvent(SlotEventConstantsBehavior.FADE_IN_SOUND, {
      id: SoundConstant.FREGAME_BGLOOP,
      vol: 0.5,
      key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD,
    });
    this.showRetriggerText();
    this.showRetriggerSpine();
    dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, {
      id: SoundConstant.RETRIGGER_POP_UP_SOUND,
      vol: 1,
      loop: false,
      key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD,
    });
    delayedCall(
      this.STR_CHANGE_GRID,
      SlotConstantsBehavior.DURATION_200,
      () => {
        killDelayedCall(this.STR_CHANGE_GRID);
        this.updateStaticGrid();
      },
      this
    );
  }
  /**
     * overrided to update text
     */
  protected showRetriggerText(): void {
    this.retriggerText2.alpha = 0;
    this.retriggerText2.visible = true;
    this.retriggerText2.rotation = -0.16;
    this.retriggerText2.setText(
      gameConstants.RETRIGGER_PLUS +
      (ingenuity.parserModel as GameParserModel).getRetriggerFreeSpins() + " " +
      ingenuity.currentGame.cache.getJSON("lang").free_Spins.text
    );
    const fadeInTween = ingenuity.currentGame.add
      .tween(this.retriggerText2)
      .to({ alpha: 1 }, 2000, Linear.None, true, 700, 0, false);
    fadeInTween.onComplete.addOnce(() => {
      fadeInTween.stop();
      ingenuity.currentGame.tweens.remove(fadeInTween);
    }, this);
  }
  /**
     * overrided to play portrait feature specific anim
     */
  protected playRetriggerPortraitSpine(): void {
    dispatcher.fireEvent(eventDispatchers.HIDE_TOP_LOGO_ON_BANNER_FG);
    this.retriggerPortraitSpine.visible = true;
    this.retriggerPortraitSpine.playAnim(this.ANIMATION_RETRIGGER_BASE_PORTRAIT, false);
    this.retriggerPortraitSpine.onComplete.addOnce(() => {
      this.retriggerPortraitSpine.playAnim(SlotAnimationConstant.FG_INTRO_PORTRAIT_BG_STATIC, false);
      this.retriggerPortraitSpine.onComplete.addOnce(() => {
        this.retriggerPortraitSpine.playAnim(this.ANIMATION_RETRIGGER_OUT_BASE, false);
      }, this);
    }, this);
  }
  /**
   * overrided to play desktop feature specific anim
   */
  protected playRetriggerDesktopSpine(): void {
    this.retriggerSpine.visible = true;
    this.retriggerSpine2.visible = true;
    this.retriggerSpine.playAnim(this.ANIMATION_RETRIGGER_BASE, false);
    this.retriggerSpine2.playAnim(this.ANIMATION_RETRIGGER_TEXT, false);
    this.retriggerSpine2.onComplete.addOnce(() => {
      this.retriggerSpine.playAnim(SlotAnimationConstant.FG_INTRO_DESKTOP_BG_STATIC, false);
      this.retriggerSpine2.playAnim(SlotAnimationConstant.FG_INTRO_DESKTOP_STATIC, false);
      this.showFreeGameCounterAnimation();
      this.retriggerSpine2.onComplete.addOnce(() => {
        this.retriggerSpine.playAnim(this.ANIMATION_RETRIGGER_OUT_BASE, false);
        this.retriggerSpine2.playAnim(this.ANIMATION_RETRIGGER_OUT_TEXT, false);
        this.hideRetriggerText();
        this.retriggerSpine2.onComplete.addOnce(() => {
          this.onRetriggerIntroComplete();
        }, this);
      }, this);
    }, this);
  }
  /**
   * overrided to on complete flow
   */
  protected onRetriggerIntroComplete() {
    this.retriggerSpine.visible = false;
    this.retriggerPortraitSpine && (this.retriggerPortraitSpine.visible = false);

  }
  /**
     * overrided to banner hide
     */
  protected hideRetriggerText(): void {
    const fadeOutTween = ingenuity.currentGame.add
      .tween(this.retriggerText2)
      .to({ alpha: 0 }, 100, Linear.None, true, 0, 0, false);
    fadeOutTween.onComplete.addOnce(() => {
      dispatcher.fireEvent(eventDispatchers.SHOW_TOP_LOGO_ON_BANNER_FG);
      fadeOutTween.stop();
      ingenuity.currentGame.tweens.remove(fadeOutTween);
    }, this);
  }
  /**
   * overrided to manage delay
   */
  protected updateTotalFreeSpin() {
    dispatcher.fireEvent(SlotEventConstantsBehavior.FADE_OUT_SOUND, { id: SoundConstant.FREGAME_BGLOOP, vol: 1, key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD });
    delayedCall(this.STR_NEXT_SNED_PRESENTATION, 2000, () => {
      killDelayedCall(this.STR_NEXT_SNED_PRESENTATION);
      dispatcher.fireEvent(SlotEventConstantsBehavior.MOVE_TO_NEXT_FREESPIN_AFTER_RETRIGGER);
    }, this);
  }
}
